import { getJSON, post } from './ultile';
import {
  STORE_HOST,
  UPDATE_LOADING,
  SET_PAYTYPE,
  SET_DEFAULT_PAYTYPE,
  SET_HAS_LOAD_PAYTYPE,
  SET_SHOW_CHANNEL_STATUS,
  SET_INIT_DATA
} from './index';
import { storePayTypeList, setDefaultPayType } from './storager';
import globalConfig from '@utiles/officialStore/globalConfig';

// jp从引入的常量
import { JPSTORE_SHORT_HOST, JPSTORE_USER_INFO, JPSTORE_INIT_DATA } from './jp';
import { isArray } from '@utiles/officialStore';

// mutations动作
export const UPDATE_COIN = 'update_coin';
export const UPDATE_BALANCE_LIST = 'update_balance_list';
export const UPDATE_DEFAULT_CURRENCY = 'update_default_currency';
export const UPDATE_BOOL_ENOUGH_BALANCE = 'update_bool_enough_balance';
export const UPDATE_IS_AGREE_COINS_PAY = 'update_is_agree_coins_pay';
export const UPDATE_SHOW_COIN_ENTRY = 'update_show_coin_entry';

// actions动作
export const GET_BALANCE_INIT_DATA = 'get_balance_init_data';
export const GET_BALANCE_USER_DATA = 'get_balance_user_data';
export const GET_BALANCE_ONE_USER_DATA = 'get_balance_one_user_data';
export const POST_ORDER_JP_COINS = 'post_order_jp_coins';
export const GET_BALANCE_USER_DATA_OF_OPEN = 'get_balance_user_data_of_open';

// 接口路径
export const INIT_DATA_ACTION = 'user_balance/init_data';
export const USER_DATA_ACTION = 'user_balance/user_data';
export const POINTS_PAY_ACTION = 'points_pay/submit';

// 存储在localStorage中的储值过代币的uid数组，用于储值化uid登录时，储值代币时的自动勾选条款
export const COINS_HAS_PAYED_UID_RECORD = 'coins_has_payed_record';

// 获取储值过代币的uid
export const boolCurAccountHasPayCoins = uid => {
  const uidArr = globalConfig.getLclStorageItem(COINS_HAS_PAYED_UID_RECORD);
  if (!isArray(uidArr)) {
    return false;
  }
  return uidArr.includes(uid);
};

// 保存储值过代币的uid
export const setHasPayCoinsUid = uid => {
  const uidArr = globalConfig.getLclStorageItem(COINS_HAS_PAYED_UID_RECORD);
  if (isArray(uidArr)) {
    if (!boolCurAccountHasPayCoins(uid)) {
      globalConfig.setLclStorageItem(COINS_HAS_PAYED_UID_RECORD, [
        ...uidArr,
        uid
      ]);
    }
  } else {
    globalConfig.setLclStorageItem(COINS_HAS_PAYED_UID_RECORD, [uid]);
  }
};

// 地区 对 币种 的映射表:一对多
const areaCurrencyMap = {
  US: 'USD',
  JP: 'JPY',
  KR: 'KRW',
  TW: 'TWD',
  VN: 'VND',
  TH: 'THB',
  MY: 'MYR',
  SG: 'SGD',
  ID: 'IDR',
  PH: 'PHP',
  HK: 'HKD',
  MO: 'USD',
  RU: 'RUB',
  DE: 'EUR',
  GB: 'GBP',
  AU: 'AUD',
  FR: 'EUR',
  FI: 'EUR',
  DK: 'EUR',
  NL: 'EUR',
  CA: 'CAD',
  SE: 'EUR',
  PL: 'PLN',
  IT: 'EUR',
  CH: 'EUR',
  BE: 'EUR',
  SA: 'SAR',
  AE: 'AED',
  EG: 'USD',
  KW: 'USD',
  QA: 'QAR',
  OM: 'USD',
  BH: 'USD',
  GLOBAL: 'USD'
};

// 币种 对 地区 的映射表:一对一
const currencyAreaMap = {
  GLOBAL: 'USD', // Global
  US: 'USD', // United States
  JP: 'JPY', // 日本
  KR: 'KRW', // 한국
  TW: 'TWD', // 台灣地區
  VN: 'VND', // Việt Nam
  TH: 'THB', // ไทย
  MY: 'MYR', // Malaysia
  SG: 'SGD', // Singapore
  ID: 'IDR', // Indonesia
  PH: 'PHP', // Philippines
  HK: 'HKD', // 香港特別行政區
  RU: 'RUB', // Rossiya
  DE: 'EUR', // Germany
  GB: 'GBP', // United Kingdom
  AU: 'AUD', // Australia
  CA: 'CAD', // Canada
  PL: 'PLN' // 波兰
};

// 通过地区 获得 币种：一对多
export const getCurrencyByArea = areaCode => {
  return areaCurrencyMap[areaCode] ? areaCurrencyMap[areaCode] : '';
};

// 通过币种 获得 地区：一对一
export const getAreaByCurrency = currency => {
  const keys = Object.keys(currencyAreaMap);
  for (let i = 0, length = keys.length; i < length; i++) {
    if (currencyAreaMap[keys[i]] === currency) {
      return keys[i];
    }
  }
  return '';
};

// 从币种余额列表中找到对应的币种
const findBalanceItem = (balanceList, currency) => {
  const balanceItem = balanceList.find(item => item?.currency === currency);
  if (balanceItem) {
    return balanceItem;
  } else {
    return {
      currency,
      amount: '0'
    };
  }
};

export default {
  state: {
    showCoinEntry: false, // 是否显示平台币入口
    curCoinAmount: '0', // 当前显示的代币余额
    curCoinCurrency: '', // 当先显示的代币币种
    balanceList: [], // 代金币列表：各个币种的
    defaultCurrency: '', // 默认币种
    location: '', // 当前币种所对应的地区
    boolEnoughBalance: '', // 是否足够代币余额支付
    payAfterAmount: '', // 支付之后剩余的代币余额
    payAfterCurrency: '', // 支付之后剩余的代币余额的币种单位
    isAgreeCoinsPay: false // 首次储值平台币是否同意协议
  },
  getters: {
    getPointPayChannelName(_state, _getters, _rootState, rootGetters) {
      return rootGetters.isJpPlatform ? 'points_pay' : 'user_balance_pay';
    },
    getCoinsName(_state, _getters, _rootState, rootGetters) {
      if (rootGetters?.isJpPlatform) {
        return '交換コイン';
      }
      if (_rootState.gameId == 191) {
        return 'Z-BIT';
      }
      let coinsName = _rootState.letter.voucherYue;
      return coinsName;
    }
  },
  mutations: {
    [UPDATE_SHOW_COIN_ENTRY](state, status) {
      state.showCoinEntry = status;
    },
    [UPDATE_COIN](state, { amount, currency }) {
      state.curCoinAmount = amount;
      state.curCoinCurrency = currency;
      state.location = getAreaByCurrency(currency);
    },
    [UPDATE_BALANCE_LIST](state, balanceList) {
      state.balanceList = balanceList;
    },
    [UPDATE_DEFAULT_CURRENCY](state, defaultCurrency) {
      state.defaultCurrency = defaultCurrency;
    },
    [UPDATE_BOOL_ENOUGH_BALANCE](
      state,
      { boolEnoughBalance, payAfterAmount, payAfterCurrency }
    ) {
      state.boolEnoughBalance = boolEnoughBalance;
      state.payAfterAmount = payAfterAmount;
      state.payAfterCurrency = payAfterCurrency;
    },
    [UPDATE_IS_AGREE_COINS_PAY](state, isAgreeCoinsPay) {
      state.isAgreeCoinsPay = isAgreeCoinsPay;
    }
  },
  actions: {
    // 用户代币初始化
    [GET_BALANCE_INIT_DATA](
      { state, commit, rootState, rootGetters },
      payload
    ) {
      return new Promise(resolve => {
        const location =
          payload && payload.location && payload.location !== ''
            ? payload.location
            : '';

        commit(UPDATE_LOADING, true);
        commit(SET_HAS_LOAD_PAYTYPE, false);
        commit(SET_SHOW_CHANNEL_STATUS, false);

        const params = {
          gameId: rootState.gameId,
          serverId: rootState.pcServerId,
          roleId: rootState.roleId,
          roleName: encodeURIComponent(rootState.roleName),
          language: rootState.lang,
          location: state.location
        };
        if (location) {
          Object.assign(params, { location });
        }
        let host = '';
        let path = '';
        if (rootGetters.isJpPlatform) {
          host = JPSTORE_SHORT_HOST;
          path = JPSTORE_INIT_DATA;
        } else {
          host = STORE_HOST;
          path = INIT_DATA_ACTION;
        }

        getJSON(host + path, params).then(({ res }) => {
          if (parseInt(res.result, 10) !== 1) {
            resolve(false);
            return;
          }
          let paytype = res.data.paytype_list.filter(item => {
            return (
              item?.f_pay_type == rootState.defaultPaytype?.f_pay_type &&
              item?.pay_type == rootState.defaultPaytype?.pay_type
            );
          });
          if (paytype && paytype.length && paytype[0]) {
            paytype = paytype[0];
          }
          if (paytype.child && paytype.child.length) {
            paytype = Object.assign({}, paytype, {
              selectChildIndex: 0
            });
          }
          commit(SET_DEFAULT_PAYTYPE, res.data);
          commit(UPDATE_DEFAULT_CURRENCY, res.data.product_currency);
          // 存在localStorage
          storePayTypeList(res.data.paytype_list);
          setDefaultPayType(res.data?.paytype || res.data.paytype_list[0]);
          commit(SET_HAS_LOAD_PAYTYPE, true);
          commit(SET_SHOW_CHANNEL_STATUS, true);
          commit(SET_PAYTYPE, paytype);
          commit(UPDATE_LOADING, false);
          commit(SET_INIT_DATA, res.data);
          resolve(true);
        });
      });
    },
    // 获取代币余额
    [GET_BALANCE_USER_DATA](
      { state, commit, rootState, rootGetters },
      payload
    ) {
      return new Promise(resolve => {
        let params = {};
        let host = '';
        let path = '';
        if (rootGetters.isJpPlatform) {
          host = JPSTORE_SHORT_HOST;
          path = JPSTORE_USER_INFO;
        } else {
          host = STORE_HOST;
          path = USER_DATA_ACTION;
          params = {
            game_id: rootState.gameId
          };
        }
        commit(UPDATE_LOADING, true);
        getJSON(host + path, params).then(({ res }) => {
          if (parseInt(res.result, 10) !== 1) {
            commit(UPDATE_LOADING, false);
            resolve(false);
            return;
          }
          // 兼容balanceList万一没有返回数组的情况
          const balanceList = /Array/i.test(
            res.data.balanceList.constructor.toString()
          )
            ? res.data.balanceList
            : [];
          // 当前要显示的币种和余额
          let defaultCurrency = '';
          if (rootGetters.isJpPlatform) {
            // 日本固定币种
            defaultCurrency = 'JPY';
          } else {
            if (
              (payload && payload.useDefaultCurrency) ||
              state.defaultCurrency !== ''
            ) {
              // 条件1：代币页面使用init_data接口返回的默认币种
              // 条件2：如果已经进入过代币页面，则init_data会被调用，也就产生了默认币种，这个时候使用init_data返回的的默认币种
              defaultCurrency = state.defaultCurrency;
            } else {
              // 钱包页面默认当前接口返回的第一个
              defaultCurrency = balanceList?.[0]?.currency
                ? balanceList[0]?.currency
                : '';
            }
          }
          // 找出当前币种的信息
          const curBalance = findBalanceItem(balanceList, defaultCurrency);
          // 如果balanceList是个空数组就是没有储值过代金币，如果是uid登录的话后台限制了会返回空数组，这时要靠浏览器存的记录来判断（记录是：储值过代币的uid）
          commit(
            UPDATE_IS_AGREE_COINS_PAY,
            balanceList.length > 0 ||
              boolCurAccountHasPayCoins(rootState.login.uid)
          );

          commit(UPDATE_BALANCE_LIST, balanceList);
          commit(UPDATE_COIN, curBalance);
          commit(UPDATE_LOADING, false);
          resolve(true);
        });
      });
    },
    // 获取特定的代币余额
    [GET_BALANCE_ONE_USER_DATA]({ rootState, rootGetters }, area) {
      const currency = getCurrencyByArea(area);
      let params = {};
      let host = '';
      let path = '';
      if (rootGetters.isJpPlatform) {
        host = JPSTORE_SHORT_HOST;
        path = JPSTORE_USER_INFO;
      } else {
        host = STORE_HOST;
        path = USER_DATA_ACTION;
        params = {
          currency,
          game_id: rootState.gameId
        };
      }
      return getJSON(host + path, params);
    },
    // 消费代币
    [POST_ORDER_JP_COINS](_context, params) {
      const newParams = Object.assign({}, params, {
        flowType: '-1'
      });
      return new Promise((resolve, reject) => {
        post(JPSTORE_SHORT_HOST + POINTS_PAY_ACTION, newParams, {
          withCredentials: true
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            resolve(res);
          } else {
            reject({ errmsg, res });
          }
        });
      });
    },
    // 获取是否开启代币入口
    [GET_BALANCE_USER_DATA_OF_OPEN]({ rootState, commit, rootGetters }) {
      return new Promise(resolve => {
        let params = {};
        let host = '';
        let path = '';
        if (rootGetters.isJpPlatform) {
          host = JPSTORE_SHORT_HOST;
          path = JPSTORE_USER_INFO;
        } else {
          host = STORE_HOST;
          path = USER_DATA_ACTION;
          params = {
            game_id: rootState.gameId
          };
        }
        getJSON(host + path, params).then(({ res }) => {
          if (parseInt(res.result, 10) !== 1) {
            commit(UPDATE_SHOW_COIN_ENTRY, false);
            resolve(false);
            return;
          }
          // 兼容balanceList万一没有返回数组的情况
          const balanceList = /Array/i.test(
            res.data.balanceList.constructor.toString()
          )
            ? res.data.balanceList
            : [];
          // 先关闭
          commit(UPDATE_SHOW_COIN_ENTRY, false);
          resolve(false);
          // if (balanceList.length > 0) {
          //   commit(UPDATE_SHOW_COIN_ENTRY, true);
          //   resolve(true);
          // } else {
          //   commit(UPDATE_SHOW_COIN_ENTRY, false);
          //   resolve(false);
          // }
        });
      });
    }
  }
};
